import React from 'react';
import styles from './SectionBlock.module.css';

export interface SectionBlockProps {
  title: string;
  icon?: string;
  status?: 'complete' | 'in_progress' | 'pending';
  showRunButton?: boolean;
  onRunUpdate?: () => void;
  runButtonDisabled?: boolean;
  runButtonLoading?: boolean;
  children: React.ReactNode;
  className?: string;
  secondaryAction?: React.ReactNode;
}

/**
 * SectionBlock - Unified section styling for both Report Card and QC Workflow
 *
 * Features:
 * - Consistent border/background styling
 * - Optional status indicator
 * - Optional "BAM_check" button (QC Workflow only)
 * - Icon support
 */
export function SectionBlock({
  title,
  icon = '',
  status,
  showRunButton = false,
  onRunUpdate,
  runButtonDisabled = false,
  runButtonLoading = false,
  children,
  className = '',
  secondaryAction
}: SectionBlockProps) {
  const statusIcon = status === 'complete' ? '✓' : status === 'in_progress' ? '⏳' : '';

  return (
    <section className={`${styles.section} ${className}`}>
      <div className={styles.header}>
        <h3 className={styles.title}>
          {icon && <span className={styles.icon}>{icon}</span>}
          {title}
          {statusIcon && <span className={styles.statusIcon}>{statusIcon}</span>}
        </h3>
        {(showRunButton || secondaryAction) && (
          <div className={styles.actions}>
            {secondaryAction}
            {showRunButton && (
              <button
                type="button"
                onClick={onRunUpdate}
                disabled={runButtonDisabled || runButtonLoading}
                className={styles.runButton}
              >
                {runButtonLoading ? 'Running...' : 'BAM_check'}
              </button>
            )}
          </div>
        )}
      </div>
      <div className={styles.content}>{children}</div>
    </section>
  );
}

export default SectionBlock;
